import { useState } from 'react'
import { Loader2 } from 'lucide-react'
import { useAuth } from '../../store/auth'

export function LoginPage() {
  const login = useAuth((s) => s.login)
  const error = useAuth((s) => s.error)
  const [username, setUsername] = useState('garagesanmarco')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    await login(username, password)
    setBusy(false)
  }

  return (
    <div className="flex h-dvh items-center justify-center bg-ink-950 p-4">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded bg-brand-600">
            <img src="/brand/logo.svg" alt="" className="h-5 w-5 brightness-0 invert" />
          </span>
          <div>
            <p className="text-base font-bold text-white">Garage San Marco</p>
            <p className="text-2xs uppercase tracking-wider text-ink-400">Gestionale</p>
          </div>
        </div>

        <form onSubmit={submit} className="rounded border border-white/10 bg-ink-900 p-5">
          <h1 className="mb-4 text-[15px] font-semibold text-white">Accedi al pannello</h1>

          <label className="mb-1 block text-2xs font-semibold uppercase tracking-wide text-ink-400">Username</label>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="mb-3 h-9 w-full rounded border border-white/10 bg-ink-950 px-3 text-[13px] text-white outline-none focus:border-brand-600"
            autoFocus
          />
          <label className="mb-1 block text-2xs font-semibold uppercase tracking-wide text-ink-400">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mb-4 h-9 w-full rounded border border-white/10 bg-ink-950 px-3 text-[13px] text-white outline-none focus:border-brand-600"
          />

          {error && <p className="mb-3 text-xs font-medium text-brand-500">{error}</p>}

          <button type="submit" disabled={busy} className="btn btn-primary w-full py-2">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Accedi'}
          </button>
        </form>
        <p className="mt-3 text-center text-2xs text-ink-500">
          Ambiente locale · qualsiasi password è accettata (bypass dev)
        </p>
      </div>
    </div>
  )
}
